import { render, staticRenderFns } from "./LawDecisionList.vue?vue&type=template&id=a5ef49ee&"
import script from "./LawDecisionList.vue?vue&type=script&lang=js&"
export * from "./LawDecisionList.vue?vue&type=script&lang=js&"
import style0 from "./LawDecisionList.vue?vue&type=style&index=0&id=a5ef49ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports